import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import { HomeHeadVideo } from "./HomeHeadVideo";
import { HomeHeadVideoV } from "./HomeHeadVideoV";
import { LoadScreenMin } from "./UI/LoadScreenMin";
import { AfishaHome } from "./Afisha/AfishaHome";


export const DemoHome = () => {

    const [t] = useTranslation("global");

    const { loaction } = useLocation();
    const [wide, setWide] = useState();

    useEffect(() => {
        if (window.innerWidth < window.innerHeight) {
            setWide(false)
        }
        if (window.innerWidth > window.innerHeight) {
            setWide(true)
        }
    }, [])

    useEffect(() => {
        const resizeHandeler = (e) => {
            if (e.target.window.innerWidth < e.target.window.innerHeight) {
                setWide(false)
            }
            if (e.target.window.innerWidth > e.target.window.innerHeight) {
                setWide(true)
            }
            // console.log(e.target.window.innerWidth)
            // console.log(e.target.window.innerHeight)
        }

        window.addEventListener('resize', resizeHandeler)
        return function () {
            window.addEventListener('resize', resizeHandeler)
        }
    }, [loaction])

    return (
        <>
            <Helmet>
                <title>{t("mainTag.title")}</title>
                <meta name="description" content='Первое в России шоу-пространство "Ленинград Центр"'></meta>
                <meta name="keywords" content="шоу- пространство, шоу пространство, ленинград центр, центр ленинград, мюзикл, шоу, представление, афиша"></meta>
                {/* <meta property="og:image" content={data.headLayoutImageType ? `/api/shows/head-wide-img/${data.id})` : "/Show/091A8332.jpg"} /> */}
                <meta property="og:title" content={t("mainTag.title")} />
                <meta property="og:description" content='Первое в России шоу-пространство "Ленинград Центр"' />
                <meta property="og:image" content={'https://leningradcenter.ru/lc-logo.png'} />
                <meta property="og:type" content="theatre" />
                <meta property="og:url" content="https://leningradcenter.ru/" />
            </Helmet>
            <Suspense fallback={<LoadScreenMin height={100} />}>
                {wide !== null &&
                    <>
                        {wide === true &&
                            <>
                                {/* {console.log(wide)} */}
                                <HomeHeadVideo />
                            </>}
                        {wide === false &&
                            <>
                                {/* {console.log(wide)} */}
                                <HomeHeadVideoV />
                            </>

                        }
                    </>}
            </Suspense>
            <AfishaHome />
            {/* <HomeAfisha /> */}
            {/* <Subscription /> */}
            {/* <PeopleLc /> */}
        </>
    )
}